import { prerollTag } from './ads'
import { GA_Event } from '../Components/Analytics/Analytics'

const flowplayer = window.flowplayer;

const fpInit = (options, onLoad) => {
    return flowplayer(options.selector, {
        key: '$509034830680622',
        splash: true,
        poster: options.poster,
        ratio: 9 / 16,
        autoplay: false,
        share: false,
        cuepoints: [3],
        qualities: [-1, 0, 1, 2, 3, 4],
        quality: 1,
        ima: {
            ads: [
                {
                    time: 0,
                    adTag: prerollTag
                }],
            locale: "he"
        },
        clip: {
            sources: [
                {
                    type: "application/x-mpegurl",
                    src: options.mainUrl.replace("mediadownload.ynet.co.il", "ynethd-i.akamaihd.net/i").replace("_1600.mp4", "_,800,1600,.mp4.csmil/master.m3u8")
                },
                {
                    type: "video/mp4",
                    src: options.mainUrl
                }
            ]
        }
    }).on('cuepoint', () => {
        if (typeof onLoad === 'function') onLoad();
        GA_Event('Video_Play', options.mainUrl);
    });
}
export {
    fpInit
}


// WEBPACK FOOTER //
// ./src/static/player.js